import { render, staticRenderFns } from "./SidebarItem.vue?vue&type=template&id=798cb873"
import script from "./SidebarItem.vue?vue&type=script&lang=js"
export * from "./SidebarItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\androidcode\\zf_tms_vue\\tms_vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('798cb873')) {
      api.createRecord('798cb873', component.options)
    } else {
      api.reload('798cb873', component.options)
    }
    module.hot.accept("./SidebarItem.vue?vue&type=template&id=798cb873", function () {
      api.rerender('798cb873', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/classic/sidebar/SidebarItem.vue"
export default component.exports